import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class UploadFilesService {
    //private baseUrl = 'http://localhost:53666/api/login/subirDocumento';
    private baseUrl = environment.servidorHttp+"login/subirDocumento";
    //private baseUrl = "http://srvestudiorodriguez.quan.com.ar/api/login/subirDocumento";
    constructor(private http: HttpClient) { }
  
    upload(file: File): Observable<HttpEvent<any>> {
      const formData: FormData = new FormData();
  
      formData.append('nombreDocumento', file.name);
      formData.append('archivo', file);
      
      const req = new HttpRequest('POST', this.baseUrl, formData, {
        reportProgress: true,
        responseType: 'json'
      });
  
      return this.http.request(req);
    }
  
    getFiles(): Observable<any> {
      return this.http.get('${this.baseUrl}/files');
    }
  }

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFilesPDNotificacionService {
    private baseUrl = environment.servidorHttp+"login/subirDocumentoNotificacion";
    constructor(private http: HttpClient) { }
  
    upload(file: File): Observable<HttpEvent<any>> {
      const formData: FormData = new FormData();
  
      formData.append('nombreDocumento', file.name);
      formData.append('archivo', file);
      
      const req = new HttpRequest('POST', this.baseUrl, formData, {
        reportProgress: true,
        responseType: 'json'
      });
  
      return this.http.request(req);
    }
  
    getFiles(): Observable<any> {
      return this.http.get('${this.baseUrl}/files');
    }
  }